import React, { useState, useEffect, useRef } from 'react';
import { Button, Row, Col, Overlay, Tooltip, } from 'react-bootstrap';
import './message.css'
import Summarize from './summarize.jsx';
import { sendRequest } from "./token_util";
import Cookie from "universal-cookie";
import 'bootstrap-icons/font/bootstrap-icons.css';

function SummarizeWithCol({ conversations, language, translations }) {
    const [summarize, setSummarize] = useState([]); // 将初始值设置为空数组
    const [processing, setProcessing] = useState(false); // 新增状态：是否正在处理请求
    const [showSummarizeTooltip, setShowSummarizeTooltip] = useState(false);
    const buttonSummarizeRef = useRef(null);
    const [saveRequested, setSaveRequested] = useState(false);
    const messagesEndRef = useRef(null);

    const cookie = new Cookie();
    const loginInfo = cookie.get('login-info');

    const handleSummarize = async () => {        
        let uid = "";
        if (loginInfo !== undefined) {
            uid = loginInfo['uid'];
        }

        const data = {
            message: conversations,
            language: language,
            uid: uid,
        };

        if (conversations.length > 0) {
            setProcessing(true); // 设置处理状态为 true
            setSummarize([]); // 清空 summarize 状态
                await sendRequest("/summarize", data, handleChunkReceived);
            setProcessing(false); // 设置处理状态为 false
        }
    };



    const handleChunkReceived = (chunk) => {
        // console.log("Chunk received in parent component:", chunk);
      
        addOrUpdateSummarize(chunk);
    };

    const addOrUpdateSummarize = (chunk) => {
        
        setSummarize((prevSummarize) => [...prevSummarize, chunk]);
    };



    const handleSaveSummarize = () => {
        
        setSaveRequested(true);
    };

    return (
        <React.Fragment>
            <Row className="mt-2">
                <Col>
                    <Button
                        ref={buttonSummarizeRef}
                        variant="outline-success"
                        className="me-2" // 添加右边距
                        onClick={handleSummarize}
                        disabled={processing} // 根据处理状态禁用按钮
                        onMouseEnter={() => setShowSummarizeTooltip(true)}
                        onMouseLeave={() => setShowSummarizeTooltip(false)}
                        style={{ display: "inline-block", width: "auto" }}
                    >                    
                        <i className="bi bi-pencil-square"></i> 总结
                    </Button>
                    <Overlay target={buttonSummarizeRef.current} show={showSummarizeTooltip} placement="top">
                        {(props) => (
                            <Tooltip id="overlay-summarize" {...props} className="custom-tooltip">
                                {"切换翻译的语言可以改变总结输出的语言"}
                            </Tooltip>
                        )}
                    </Overlay>

                    <Button
                        variant="outline-success"
                        className="me-2" // 添加右边距
                        onClick={handleSaveSummarize}
                        disabled={processing} // 根据处理状态禁用按钮
                        style={{ display: "inline-block", width: "auto" }}
                    >                    
                        <i className="bi bi-download"></i>
                    </Button>
                </Col>
            </Row>
            <Row className="mt-2" ref={messagesEndRef}>
                {summarize.length > 0 && (
                    <Summarize
                        height="100vh"
                        message={summarize}
                        saveRequested={saveRequested}
                        onSaved={() => setSaveRequested(false)}
                    />
                )}
            </Row>
        </React.Fragment>
    );
}
  
export default SummarizeWithCol;